'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp; // import {
//   TasksConnector,
// } from "./query";
// import View from "./View/Gantt";


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

var _View = require('./View');

var _View2 = _interopRequireDefault(_View);

var _reactApollo = require('react-apollo');

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TasksPage = (_temp = _class = function (_Page) {
  _inherits(TasksPage, _Page);

  function TasksPage() {
    _classCallCheck(this, TasksPage);

    return _possibleConstructorReturn(this, _Page.apply(this, arguments));
  }

  TasksPage.prototype.componentWillMount = function componentWillMount() {
    var _context$query = this.context.query,
        tasksConnection = _context$query.tasksConnection,
        createTaskProcessor = _context$query.createTaskProcessor,
        updateTaskProcessor = _context$query.updateTaskProcessor,
        createTimerProcessor = _context$query.createTimerProcessor,
        updateTimerProcessor = _context$query.updateTimerProcessor,
        deleteTaskReaction = _context$query.deleteTaskReaction;
    var View = this.props.View; // return;

    this.Renderer = (0, _reactApollo.compose)((0, _reactApollo.graphql)((0, _graphqlTag2.default)(tasksConnection)), (0, _reactApollo.graphql)((0, _graphqlTag2.default)(createTaskProcessor), {
      name: "createTaskProcessor"
    }), (0, _reactApollo.graphql)((0, _graphqlTag2.default)(updateTaskProcessor), {
      name: "updateTaskProcessor"
    }), (0, _reactApollo.graphql)((0, _graphqlTag2.default)(createTimerProcessor), {
      name: "createTimerProcessor"
    }), (0, _reactApollo.graphql)((0, _graphqlTag2.default)(updateTimerProcessor), {
      name: "updateTimerProcessor"
    }), // graphql(gql(createTaskReactionProcessor), {
    //   name: "createTaskReactionProcessor",
    // }),
    (0, _reactApollo.graphql)((0, _graphqlTag2.default)(deleteTaskReaction), {
      name: "deleteTaskReaction"
    }))(View);
    _Page.prototype.componentWillMount && _Page.prototype.componentWillMount.call(this);
  };

  TasksPage.prototype.setPageMeta = function setPageMeta() {
    var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _Page.prototype.setPageMeta.call(this, _extends({
      title: "Задачи"
    }, meta));
  };

  TasksPage.prototype.getFilters = function getFilters() {
    var uri = this.context.uri;

    var _uri$query = uri.query(true),
        status_in = _uri$query.status_in,
        projectId = _uri$query.projectId,
        filters = _uri$query.filters;

    if (status_in && !Array.isArray(status_in)) {
      status_in = [status_in];
    }

    try {
      filters = filters && JSON.parse(filters) || null;
    } catch (error) {
      console.error(console.error(error));
    }

    var result = _extends({}, filters);

    if (status_in !== undefined) {
      result.status_in = status_in;
    }

    if (projectId !== undefined) {
      result.projectId = projectId;
    }

    return result;
  }; // setFilters(filters) {
  //   const {
  //     uri,
  //     router: {
  //       history,
  //     },
  //   } = this.context;
  //   let newUri = uri.clone();
  //   let query = newUri.query(true);
  //   Object.assign(query, {
  //     ...filters,
  //   });
  //   newUri.query(query);
  //   history.push(newUri.resource());
  // }


  TasksPage.prototype.setFilters = function setFilters(filters) {
    var _context = this.context,
        uri = _context.uri,
        history = _context.router.history; // console.log("setFilters", filters);

    var newUri = uri.clone();

    try {
      filters = filters ? JSON.stringify(filters) : undefined;
    } catch (error) {
      console.error(error);
    }

    if (filters) {
      if (newUri.hasQuery) {
        newUri = newUri.setQuery({
          filters: filters
        });
      } else {
        newUri = newUri.addQuery({
          filters: filters
        });
      }
    } else {
      newUri.removeQuery("filters");
    }

    newUri.removeQuery("page");
    newUri.removeQuery("status_in");
    var url = newUri.resource(); // console.log("setFilters uri", newUri, url);

    history.push(url);
  };

  TasksPage.prototype.render = function render() {
    var _this2 = this; // return null;


    var Renderer = this.Renderer;

    var _props = this.props,
        View = _props.View,
        first = _props.first,
        propsWhere = _props.where,
        other = _objectWithoutProperties(_props, ['View', 'first', 'where']);

    var uri = this.context.uri;

    var _uri$query2 = uri.query(true),
        page = _uri$query2.page;

    var skip = void 0;
    page = page && parseInt(page) || 0;

    if (first && page > 1) {
      skip = (page - 1) * first;
    }

    var _getFilters = this.getFilters(),
        showAll = _getFilters.showAll,
        projectId = _getFilters.projectId,
        filters = _objectWithoutProperties(_getFilters, ['showAll', 'projectId']);

    var AND = [];

    if (propsWhere) {
      AND.push(propsWhere);
    }

    if (filters) {
      AND.push(filters);
    }

    var where = {
      AND: AND
    };

    if (projectId) {
      where.Project = {
        id: projectId
      };
    }

    return _Page.prototype.render.call(this, _react2.default.createElement(Renderer, _extends({
      where: where,
      first: !showAll ? first : undefined,
      skip: skip,
      page: page ? parseInt(page) : undefined,
      filters: filters || {},
      setFilters: function setFilters(filters) {
        return _this2.setFilters(filters);
      },
      showAll: showAll,
      setShowAll: function setShowAll(showAll) {
        // this.setState({
        //   showAll: status,
        // });
        // this.setFilters({
        //   ...this.getFilters(),
        // });
        _this2.setFilters(_extends({}, filters, {
          showAll: showAll ? true : undefined
        }));
      }
    }, other)));
  }; // render() {
  //   // return null;
  //   const {
  //     Renderer,
  //   } = this;
  //   let {
  //     View,
  //     first,
  //     // where,
  //     ...other
  //   } = this.props;
  //   const {
  //     uri,
  //   } = this.context;
  //   let {
  //     page,
  //   } = uri.query(true);
  //   let skip;
  //   page = page && parseInt(page) || 0;
  //   if (first && page > 1) {
  //     skip = (page - 1) * first;
  //   }
  //   const {
  //     projectId,
  //     ...filters
  //   } = this.getFilters();
  //   let where = {
  //     ...filters,
  //   }
  //   if(projectId) {
  //     where.Project = {
  //       id: projectId,
  //     }
  //   }
  //   return super.render(
  //     <Renderer
  //       where={where}
  //       first={first}
  //       skip={skip}
  //       page={page ? parseInt(page) : undefined}
  //       setFilters={filters => this.setFilters(filters)}
  //       getFilters={() => this.getFilters()}
  //       {...other}
  //     />
  //   );
  // }


  return TasksPage;
}(_layout2.default), _class.propTypes = _extends({}, _layout2.default.propTypes, {
  first: _propTypes2.default.number.isRequired,
  orderBy: _propTypes2.default.string.isRequired // TasksConnector: PropTypes.func.isRequired,

}), _class.defaultProps = _extends({}, _layout2.default.defaultProps, {
  first: 10,
  orderBy: "createdAt_DESC",
  View: _View2.default // TasksConnector,

}), _temp);
exports.default = TasksPage;
module.exports = exports['default'];